import { supabase } from '../supabaseClient';

export async function getPolizzaCompleta(id: string) {
  const { data, error } = await supabase
    .from('polizze')
    .select(`
      *,
      pacchetto:pacchetti_garanzia ( nome, tipologia ),
      agente:utenti ( nome, cognome, agenzia:agenzie ( nome ) )
    `)
    .eq('id', id)
    .single();

  if (error || !data) throw new Error('Polizza non trovata');
  return data;
}